<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { FlyoutTriggerProps } from '@components/overlays/flyout'

  let {
    props,
    open,
    current = false,
    children,
  }: {
    props: FlyoutTriggerProps['props']
    open: boolean
    current?: boolean
    children: Snippet
  } = $props()
</script>

<button {...props} class="button" class:-open={open} class:-current={current}>
  {@render children()}
</button>

<style>
  .button {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    height: 100%;
    padding: 0;
    border: none;
    background: none;
    color: var(--color-arsenic);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-base);
    white-space: nowrap;
    box-sizing: content-box;
  }

  .button > :global(:first-child) {
    margin-right: var(--space-2);
    transform: translateY(-1px);
  }

  .button:hover,
  .button.-open {
    color: var(--color-tapa);
    opacity: 0.6;
  }

  .button.-current {
    padding: 2px var(--space-2);
    margin: -2px calc(-1 * var(--space-2));
    border-radius: var(--border-radius);
    background-color: var(--color-primary-bright);
    color: var(--color-cerulean);
    opacity: 1;
  }

  .button :global(.caret) {
    --size: 18px;
    margin-left: var(--space-1);
    transform: translateY(1px);
  }

  @media (--header-medium-down) {
    .button > :global(:first-child) {
      margin-right: 0;
    }

    .button.-current {
      padding: var(--space-2) var(--space-3);
      margin: calc(-1 * var(--space-2)) calc(-1 * var(--space-3));
    }
  }
</style>
